import React, { useContext, useState } from "react";

import WorkOrderListingHeader from "./WorkOrderListingHeader";

import WorkOrderTable from "./WorkOrderTable";
import { LayoutContext } from "../../../context/LayoutContext";
import BaseConfirmModal from "../../../components/ui/BaseConfirmModal";

const WorkOrderList = () => {
  const { isBannerVisible } = useContext(LayoutContext);
  const [isGenerateInvoiceModalOpen, setIsGenerateInvoiceModalOpen] = useState(false);
  const [selectedWorkOrderIds, setSelectedWorkOrderIds] = useState([]);
  const [selectedWorkOrders, setSelectedWorkOrders] = useState([]);
  const [selectedEngineer, setSelectedEngineer] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [currencyMismatch, setCurrencyMismatch] = useState(null);
  const handleGenerateInvoiceClick = () => {
    const mismatched = (selectedWorkOrders || []).filter((wo) => {
      const engineerCurrency =
        wo?.engineerCurrency || wo?.engineer?.offer?.engineerCurrency || null;
      return selectedCurrency && engineerCurrency !== selectedCurrency;
    });

    if (mismatched.length > 0) {
      setCurrencyMismatch(mismatched);
      return;
    }

    setIsGenerateInvoiceModalOpen(true);
  };

  return (
    <div
      className={`bg-[#F6F6F6] sm:fixed stikcy  2xl:w-[95.2%] xl:w-[93.2%] lg:w-[90.6%] md:w-[87.5%] sm:w-[95%] w-full h-screen transition-all ${
        isBannerVisible ? "top-[106px]" : "top-[56px]"
      }`}
    >
      <WorkOrderListingHeader
        selectedWorkOrderIds={selectedWorkOrderIds}
        setIsGenerateInvoiceModalOpen={setIsGenerateInvoiceModalOpen}
        onGenerateInvoiceClick={handleGenerateInvoiceClick}
        selectedEngineer={selectedEngineer}
        status={selectedStatus}
        currency={selectedCurrency}
      />
      <WorkOrderTable
        setIsGenerateInvoiceModalOpen={setIsGenerateInvoiceModalOpen}
        isGenerateInvoiceModalOpen={isGenerateInvoiceModalOpen}
        setSelectedWorkOrderIds={setSelectedWorkOrderIds}
        selectedWorkOrderIds={selectedWorkOrderIds}
        setSelectedWorkOrders={setSelectedWorkOrders}
        setSelectedEngineer={setSelectedEngineer}
        selectedEngineer={selectedEngineer}
        setSelectedStatus={setSelectedStatus}
        setSelectedCurrency={setSelectedCurrency}
        selectedCurrency={selectedCurrency}
      />
      <BaseConfirmModal
        open={!!currencyMismatch}
        onClose={() => setCurrencyMismatch(null)}
        onConfirm={() => setCurrencyMismatch(null)}
        type="warning"
        title="Currency Mismatch"
        confirmText="OK"
        cancelText="Close"
        description={
          <div>
            <p>
              The following selected work order
              {currencyMismatch?.length > 1 ? "s have" : " has"} an engineer currency that does not
              match the selected <span className="font-medium">{selectedCurrency}</span> filter:
            </p>
            <p className="text-red-600 font-medium mt-2">
              {currencyMismatch?.map((wo) => `#${wo?.referenceId ?? wo?.id}`).join(", ")}
            </p>
            <p className="mt-2">
              Please deselect {currencyMismatch?.length > 1 ? "them" : "it"} before generating the
              invoice.
            </p>
          </div>
        }
      />
    </div>
  );
};

export default WorkOrderList;
